import React from 'react';

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({ children, className, ...props }) => {
  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};